// US places: the tracked-city table, state lookups and the nearest-city rule
// that decides which city an artist belongs to. Shared by the heat map (its
// breadcrumb and local city boards) and the homepage ("Who's moving in
// <your city>"), so both put an artist in the same place. Pure data and
// helpers, no MapLibre, so the homepage can use it without pulling the map in.

// Major US city → [lng, lat]
export const CITY_COORDS = {
  "NEW YORK": [-74.006, 40.7128], "LOS ANGELES": [-118.2437, 34.0522],
  "CHICAGO": [-87.6298, 41.8781], "HOUSTON": [-95.3698, 29.7604],
  "PHOENIX": [-112.074, 33.4484], "PHILADELPHIA": [-75.1652, 39.9526],
  "SAN ANTONIO": [-98.4936, 29.4241], "SAN DIEGO": [-117.1611, 32.7157],
  "DALLAS": [-96.797, 32.7767], "SAN JOSE": [-121.8863, 37.3382],
  "AUSTIN": [-97.7431, 30.2672], "JACKSONVILLE": [-81.6557, 30.3322],
  "FORT WORTH": [-97.3308, 32.7555], "COLUMBUS": [-82.9988, 39.9612],
  "CHARLOTTE": [-80.8431, 35.2271], "SAN FRANCISCO": [-122.4194, 37.7749],
  "INDIANAPOLIS": [-86.1581, 39.7684], "SEATTLE": [-122.3321, 47.6062],
  "DENVER": [-104.9903, 39.7392], "NASHVILLE": [-86.7816, 36.1627],
  "OKLAHOMA CITY": [-97.5164, 35.4676], "EL PASO": [-106.485, 31.7619],
  "WASHINGTON": [-77.0369, 38.9072], "DC": [-77.0369, 38.9072],
  "BOSTON": [-71.0589, 42.3601], "MEMPHIS": [-90.049, 35.1495],
  "LOUISVILLE": [-85.7585, 38.2527], "PORTLAND": [-122.6765, 45.5051],
  "LAS VEGAS": [-115.1398, 36.1699], "BALTIMORE": [-76.6122, 39.2904],
  "MILWAUKEE": [-87.9065, 43.0389], "ALBUQUERQUE": [-106.6504, 35.0844],
  "TUCSON": [-110.9265, 32.2226], "FRESNO": [-119.7871, 36.7378],
  "SACRAMENTO": [-121.4944, 38.5816], "ATLANTA": [-84.388, 33.749],
  "KANSAS CITY": [-94.5786, 39.0997], "OMAHA": [-95.9345, 41.2565],
  "COLORADO SPRINGS": [-104.8214, 38.8339], "RALEIGH": [-78.6382, 35.7796],
  "LONG BEACH": [-118.1937, 33.7701], "VIRGINIA BEACH": [-75.9779, 36.8529],
  "MINNEAPOLIS": [-93.265, 44.9778], "TAMPA": [-82.4572, 27.9506],
  "NEW ORLEANS": [-90.0715, 29.9511], "MIAMI": [-80.1918, 25.7617],
  "CLEVELAND": [-81.6944, 41.4993], "TULSA": [-95.9928, 36.154],
  "PITTSBURGH": [-79.9959, 40.4406], "CINCINNATI": [-84.512, 39.1031],
  "DETROIT": [-83.0458, 42.3314], "ST. LOUIS": [-90.1994, 38.627],
  "SAINT LOUIS": [-90.1994, 38.627], "ORLANDO": [-81.3792, 28.5383],
  "BUFFALO": [-78.8784, 42.8864], "RICHMOND": [-77.436, 37.5407],
  "SALT LAKE CITY": [-111.891, 40.7608], "BIRMINGHAM": [-86.8025, 33.5207],
  "BATON ROUGE": [-91.1403, 30.4515], "JACKSON": [-90.1848, 32.2988],
  "MOBILE": [-88.0399, 30.6954], "MONTGOMERY": [-86.2999, 32.3617],
  "HUNTSVILLE": [-86.5861, 34.7304], "ANCHORAGE": [-149.9003, 61.2181],
  "HONOLULU": [-157.8583, 21.3069], "LITTLE ROCK": [-92.2896, 34.7465],
  "BAKERSFIELD": [-119.0187, 35.3733], "ANAHEIM": [-117.9145, 33.8366],
  "RIVERSIDE": [-117.3961, 33.9806], "STOCKTON": [-121.2908, 37.9577],
  "OAKLAND": [-122.2712, 37.8044], "COMPTON": [-118.2201, 33.8958],
  "INGLEWOOD": [-118.3531, 33.9617], "AURORA": [-104.8319, 39.7294],
  "BRIDGEPORT": [-73.1952, 41.1865], "NEW HAVEN": [-72.9279, 41.3082],
  "HARTFORD": [-72.6851, 41.7658], "WILMINGTON": [-75.5277, 39.7447],
  "TALLAHASSEE": [-84.2807, 30.4383], "FORT LAUDERDALE": [-80.1373, 26.1224],
  "HIALEAH": [-80.2784, 25.8576], "ST. PETERSBURG": [-82.6403, 27.7676],
  "SAVANNAH": [-81.0998, 32.0835], "AUGUSTA": [-81.9748, 33.4735],
  "BOISE": [-116.2023, 43.615], "SPRINGFIELD": [-89.6501, 39.7817],
  "ROCKFORD": [-89.094, 42.2711], "PEORIA": [-89.5926, 40.6936],
  "FORT WAYNE": [-85.1394, 41.1306], "EVANSVILLE": [-87.5711, 37.9716],
  "SOUTH BEND": [-86.252, 41.6764], "DES MOINES": [-93.6091, 41.6005],
  "CEDAR RAPIDS": [-91.6656, 41.9779], "WICHITA": [-97.3301, 37.6872],
  "TOPEKA": [-95.689, 39.0473], "LEXINGTON": [-84.4947, 38.0406],
  "SHREVEPORT": [-93.7502, 32.5252], "WORCESTER": [-71.8023, 42.2626],
  "GRAND RAPIDS": [-85.6681, 42.9634], "LANSING": [-84.5555, 42.7325],
  "FLINT": [-83.6875, 43.0125], "ANN ARBOR": [-83.743, 42.2808],
  "ST. PAUL": [-93.09, 44.9537],
  "SAINT PAUL": [-93.09, 44.9537], "DULUTH": [-92.1005, 46.7867],
  "GULFPORT": [-89.0928, 30.3674], "HATTIESBURG": [-89.2903, 31.3271],
  "INDEPENDENCE": [-94.4155, 39.0911], "BILLINGS": [-108.5007, 45.7833],
  "MISSOULA": [-114.0119, 46.8787], "LINCOLN": [-96.6852, 40.8136],
  "HENDERSON": [-114.9817, 36.0397], "RENO": [-119.8138, 39.5296],
  "MANCHESTER": [-71.4628, 42.9956], "NEWARK": [-74.1724, 40.7357],
  "JERSEY CITY": [-74.0776, 40.7282], "PATERSON": [-74.1774, 40.9168],
  "LAS CRUCES": [-106.7893, 32.3199], "YONKERS": [-73.8988, 40.9312],
  "SYRACUSE": [-76.1474, 43.0481], "ALBANY": [-73.7562, 42.6526],
  "BRONX": [-73.8648, 40.8448], "BROOKLYN": [-73.9442, 40.6782],
  "QUEENS": [-73.7949, 40.7282], "HARLEM": [-73.9442, 40.8116],
  "GREENSBORO": [-79.792, 36.0726], "DURHAM": [-78.8986, 35.994],
  "WINSTON-SALEM": [-80.2442, 36.0999], "WINSTON SALEM": [-80.2442, 36.0999],
  "FAYETTEVILLE": [-78.8784, 35.0527], "FARGO": [-96.7898, 46.8772],
  "AKRON": [-81.519, 41.0814], "DAYTON": [-84.1916, 39.7589],
  "TOLEDO": [-83.5552, 41.6528], "EUGENE": [-123.0868, 44.0521],
  "SALEM": [-123.0351, 44.9429], "SPOKANE": [-117.426, 47.6588],
  "TACOMA": [-122.4443, 47.2529], "BELLEVUE": [-122.2015, 47.6101],
  "ERIE": [-80.0851, 42.1292], "ALLENTOWN": [-75.4902, 40.6023],
  "PROVIDENCE": [-71.4128, 41.824], "COLUMBIA": [-81.0348, 34.0007],
  "GREENVILLE": [-82.394, 34.8526], "SIOUX FALLS": [-96.7311, 43.546],
  "KNOXVILLE": [-83.9207, 35.9606], "CHATTANOOGA": [-85.3097, 35.0456],
  "CLARKSVILLE": [-87.3595, 36.5298], "ARLINGTON": [-97.1081, 32.7357],
  "CORPUS CHRISTI": [-97.3964, 27.8006], "LUBBOCK": [-101.8552, 33.5779],
  "LAREDO": [-99.5075, 27.5306], "IRVING": [-96.9489, 32.814],
  "GARLAND": [-96.6389, 32.9126], "PLANO": [-96.6989, 33.0198],
  "AMARILLO": [-101.8313, 35.222], "BROWNSVILLE": [-97.4975, 25.9017],
  "PASADENA": [-95.2091, 29.6911], "KILLEEN": [-97.7278, 31.1171],
  "MCALLEN": [-98.23, 26.2034], "NORFOLK": [-76.2859, 36.8508],
  "CHESAPEAKE": [-76.3002, 36.7682], "MADISON": [-89.4012, 43.0731],
  "GREEN BAY": [-88.0133, 44.5133], "CHEYENNE": [-104.8202, 41.14],
  "CHARLESTON": [-81.6326, 38.3498], "HUNTINGTON": [-82.4452, 38.4192],
  "ROCHESTER": [-77.6109, 43.161], 
  "SCOTTSDALE": [-111.9261, 33.4942],
  "TEMPE": [-111.94, 33.4255], "CHANDLER": [-111.8413, 33.3062],
  "MESA": [-111.8315, 33.4152], "GLENDALE": [-112.186, 33.5387],
  "PROVO": [-111.6585, 40.2338], "WEST VALLEY CITY": [-112.0011, 40.6916],
  "ST LOUIS": [-90.1994, 38.627], "NEW YORK CITY": [-74.006, 40.7128],
  "NYC": [-74.006, 40.7128], "LA": [-118.2437, 34.0522],
  "SF": [-122.4194, 37.7749], "ATL": [-84.388, 33.749],
  "PHILLY": [-75.1652, 39.9526], "PHILA": [-75.1652, 39.9526],
  // Michigan cities from actual artist data
  "YPSILANTI": [-83.6132, 42.2411], "SAGINAW": [-83.9508, 43.4195],
  "KALAMAZOO": [-85.5872, 42.2917], "PONTIAC": [-83.2910, 42.6389],
  "FARMINGTON HILLS": [-83.3677, 42.4989], "BATTLE CREEK": [-85.1797, 42.3212],
  "INKSTER": [-83.3099, 42.2942], "RIVER PARK": [-83.0458, 42.3314],
  // Common aliases in data
  "DMV": [-77.0369, 38.9072],
};

// US state abbreviation → [lng, lat] centroid (fallback)
export const STATE_CENTROIDS = {
  AL: [-86.9023, 32.3182], AK: [-153.3691, 64.2008], AZ: [-111.0937, 34.0489],
  AR: [-92.3731, 34.7999], CA: [-119.4179, 36.7783], CO: [-105.7821, 39.5501],
  CT: [-72.7554, 41.6032], DE: [-75.5277, 38.9108], FL: [-81.5158, 27.6648],
  GA: [-83.4428, 32.1656], HI: [-155.5828, 19.8968], ID: [-114.742, 44.0682],
  IL: [-89.3985, 40.6331], IN: [-86.1349, 40.2672], IA: [-93.0977, 41.878],
  KS: [-98.4842, 38.5266], KY: [-84.27, 37.8393], LA: [-91.9623, 31.2448],
  ME: [-69.4455, 45.2538], MD: [-76.6413, 39.0458], MA: [-71.3824, 42.4072],
  MI: [-85.6024, 44.3148], MN: [-94.6859, 46.7296], MS: [-89.6787, 32.7416],
  MO: [-91.8318, 37.9643], MT: [-110.3626, 46.8797], NE: [-99.9018, 41.4925],
  NV: [-116.4194, 38.8026], NH: [-71.5724, 43.1939], NJ: [-74.4057, 40.0583],
  NM: [-106.2483, 34.5199], NY: [-74.2179, 42.9538], NC: [-79.0193, 35.7596],
  ND: [-101.002, 47.5515], OH: [-82.9071, 40.4173], OK: [-97.0929, 35.0078],
  OR: [-120.5542, 43.8041], PA: [-77.1945, 41.2033], RI: [-71.4774, 41.6809],
  SC: [-81.1637, 33.8361], SD: [-99.9018, 44.572], TN: [-86.5804, 35.5175],
  TX: [-99.9018, 31.9686], UT: [-111.0937, 39.321], VT: [-72.5778, 44.0459],
  VA: [-78.6569, 37.4316], WA: [-120.7401, 47.7511], WV: [-80.4549, 38.5976],
  WI: [-89.6165, 43.7844], WY: [-107.2903, 43.076],
};

export const STATE_NAME_TO_ABBR = {
  "ALABAMA": "AL", "ALASKA": "AK", "ARIZONA": "AZ", "ARKANSAS": "AR",
  "CALIFORNIA": "CA", "COLORADO": "CO", "CONNECTICUT": "CT", "DELAWARE": "DE",
  "FLORIDA": "FL", "GEORGIA": "GA", "HAWAII": "HI", "IDAHO": "ID",
  "ILLINOIS": "IL", "INDIANA": "IN", "IOWA": "IA", "KANSAS": "KS",
  "KENTUCKY": "KY", "LOUISIANA": "LA", "MAINE": "ME", "MARYLAND": "MD",
  "MASSACHUSETTS": "MA", "MICHIGAN": "MI", "MINNESOTA": "MN", "MISSISSIPPI": "MS",
  "MISSOURI": "MO", "MONTANA": "MT", "NEBRASKA": "NE", "NEVADA": "NV",
  "NEW HAMPSHIRE": "NH", "NEW JERSEY": "NJ", "NEW MEXICO": "NM", "NEW YORK": "NY",
  "NORTH CAROLINA": "NC", "NORTH DAKOTA": "ND", "OHIO": "OH", "OKLAHOMA": "OK",
  "OREGON": "OR", "PENNSYLVANIA": "PA", "RHODE ISLAND": "RI", "SOUTH CAROLINA": "SC",
  "SOUTH DAKOTA": "SD", "TENNESSEE": "TN", "TEXAS": "TX", "UTAH": "UT",
  "VERMONT": "VT", "VIRGINIA": "VA", "WASHINGTON": "WA", "WEST VIRGINIA": "WV",
  "WISCONSIN": "WI", "WYOMING": "WY",
};

// Title-cased state name, keyed by abbreviation — for the location breadcrumb
export const STATE_ABBR_TO_NAME = Object.entries(STATE_NAME_TO_ABBR).reduce((acc, [name, abbr]) => {
  acc[abbr] = name.replace(/\w\S*/g, (w) => w.charAt(0) + w.slice(1).toLowerCase());
  return acc;
}, {});

// Title-cased city name, keyed by the same uppercase key used in CITY_COORDS
export const CITY_DISPLAY_NAME = Object.keys(CITY_COORDS).reduce((acc, key) => {
  acc[key] = key.replace(/\w\S*/g, (w) => w.charAt(0) + w.slice(1).toLowerCase());
  return acc;
}, {});

// Returns { key, dist } for the nearest entry, where dist is squared-degree
// distance (not real distance - fine for a rough "is this close?" check).
const nearestEntriesCache = new WeakMap();
export function nearestByDistance(lngLat, table) {
  let bestKey = null;
  let bestDist = Infinity;
  // Called every map frame; cache the entries array per table instead of
  // allocating ~180 pairs on each scan.
  let entries = nearestEntriesCache.get(table);
  if (!entries) {
    entries = Object.entries(table);
    nearestEntriesCache.set(table, entries);
  }
  for (const [key, coords] of entries) {
    const dLng = coords[0] - lngLat.lng;
    const dLat = coords[1] - lngLat.lat;
    const dist = dLng * dLng + dLat * dLat;
    if (dist < bestDist) {
      bestDist = dist;
      bestKey = key;
    }
  }
  return { key: bestKey, dist: bestDist };
}

// Squared degrees (~0.5°, ~50km): how close an artist has to be to a
// tracked city to count toward that city's local leaderboard. Much tighter
// than US_PROXIMITY.CITY, which only decides whether to label the view with
// a city at all.
export const LEADERBOARD_CITY_PROXIMITY = 0.25;

// Pre-sorted city keys (longest first) so partial matches prefer the most specific name
const CITY_KEYS_SORTED = Object.keys(CITY_COORDS).sort((a, b) => b.length - a.length);

// Cache of raw city string -> resolved CITY_COORDS key, since many artists
// share the same hometown - avoids re-scanning all ~180 CITY_KEYS_SORTED
// entries for a city string this function has already resolved once.
const cityKeyCache = new Map();

// Resolves an artist's city to its canonical CITY_COORDS key (e.g. "DETROIT"), or null
export function resolveCityKey(artist) {
  const cityRaw = (artist.hometown || artist.city || "").trim().toUpperCase();
  if (!cityRaw) return null;
  if (CITY_COORDS[cityRaw]) return cityRaw;
  if (cityKeyCache.has(cityRaw)) return cityKeyCache.get(cityRaw);
  // Partial match: "Atlanta, GA" → "ATLANTA"
  const match = CITY_KEYS_SORTED.find((k) => cityRaw.startsWith(k)) || null;
  cityKeyCache.set(cityRaw, match);
  return match;
}

export function resolveCoords(artist) {
  // Real geocoded coordinates (Backend/geocoding.py, via Nominatim) take
  // priority - they work for any country, not just the ~180 hardcoded US
  // cities below. The hardcoded table remains as a fast fallback for
  // artists approved before the geocoding backfill ran.
  if (typeof artist.geo_lat === "number" && typeof artist.geo_lng === "number") {
    return [artist.geo_lng, artist.geo_lat];
  }
  const cityKey = resolveCityKey(artist);
  return cityKey ? CITY_COORDS[cityKey] : null;
}

// The tracked city whose local leaderboard an artist belongs to: the
// nearest CITY_COORDS entry to where their dot sits (the same nearest-city
// rule the breadcrumb uses for the map center), or null when none is close.
export function homeCityKey(artist) {
  const coords = resolveCoords(artist);
  if (!coords) return null;
  const nearest = nearestByDistance({ lng: coords[0], lat: coords[1] }, CITY_COORDS);
  return nearest.dist <= LEADERBOARD_CITY_PROXIMITY ? nearest.key : null;
}

// The state each tracked city is in. Listed by state, flattened below.
const CITIES_BY_STATE = {
  AL: ["BIRMINGHAM", "MOBILE", "MONTGOMERY", "HUNTSVILLE"],
  AK: ["ANCHORAGE"],
  AZ: ["PHOENIX", "TUCSON", "SCOTTSDALE", "TEMPE", "CHANDLER", "MESA", "GLENDALE"],
  AR: ["LITTLE ROCK"],
  CA: ["LOS ANGELES", "SAN DIEGO", "SAN JOSE", "SAN FRANCISCO", "FRESNO", "SACRAMENTO",
    "LONG BEACH", "BAKERSFIELD", "ANAHEIM", "RIVERSIDE", "STOCKTON", "OAKLAND", "COMPTON",
    "INGLEWOOD", "LA", "SF"],
  CO: ["DENVER", "COLORADO SPRINGS", "AURORA"],
  CT: ["BRIDGEPORT", "NEW HAVEN", "HARTFORD"],
  DC: ["WASHINGTON", "DC", "DMV"],
  DE: ["WILMINGTON"],
  FL: ["JACKSONVILLE", "TAMPA", "MIAMI", "ORLANDO", "TALLAHASSEE", "FORT LAUDERDALE",
    "HIALEAH", "ST. PETERSBURG"],
  GA: ["ATLANTA", "SAVANNAH", "AUGUSTA", "ATL"],
  HI: ["HONOLULU"],
  IA: ["DES MOINES", "CEDAR RAPIDS"],
  ID: ["BOISE"],
  IL: ["CHICAGO", "SPRINGFIELD", "ROCKFORD", "PEORIA"],
  IN: ["INDIANAPOLIS", "FORT WAYNE", "EVANSVILLE", "SOUTH BEND"],
  KS: ["WICHITA", "TOPEKA"],
  KY: ["LOUISVILLE", "LEXINGTON"],
  LA: ["NEW ORLEANS", "BATON ROUGE", "SHREVEPORT"],
  MA: ["BOSTON", "WORCESTER"],
  MD: ["BALTIMORE"],
  MI: ["DETROIT", "GRAND RAPIDS", "LANSING", "FLINT", "ANN ARBOR", "YPSILANTI", "SAGINAW",
    "KALAMAZOO", "PONTIAC", "FARMINGTON HILLS", "BATTLE CREEK", "INKSTER", "RIVER PARK"],
  MN: ["MINNEAPOLIS", "ST. PAUL", "SAINT PAUL", "DULUTH"],
  MO: ["KANSAS CITY", "ST. LOUIS", "SAINT LOUIS", "ST LOUIS", "INDEPENDENCE"],
  MS: ["JACKSON", "GULFPORT", "HATTIESBURG"],
  MT: ["BILLINGS", "MISSOULA"],
  NC: ["CHARLOTTE", "RALEIGH", "GREENSBORO", "DURHAM", "WINSTON-SALEM", "WINSTON SALEM",
    "FAYETTEVILLE"],
  ND: ["FARGO"],
  NE: ["OMAHA", "LINCOLN"],
  NH: ["MANCHESTER"],
  NJ: ["NEWARK", "JERSEY CITY", "PATERSON"],
  NM: ["ALBUQUERQUE", "LAS CRUCES"],
  NV: ["LAS VEGAS", "HENDERSON", "RENO"],
  NY: ["NEW YORK", "BUFFALO", "YONKERS", "SYRACUSE", "ALBANY", "BRONX", "BROOKLYN", "QUEENS",
    "HARLEM", "ROCHESTER", "NEW YORK CITY", "NYC"],
  OH: ["COLUMBUS", "CLEVELAND", "CINCINNATI", "AKRON", "DAYTON", "TOLEDO"],
  OK: ["OKLAHOMA CITY", "TULSA"],
  OR: ["PORTLAND", "EUGENE", "SALEM"],
  PA: ["PHILADELPHIA", "PITTSBURGH", "ERIE", "ALLENTOWN", "PHILLY", "PHILA"],
  RI: ["PROVIDENCE"],
  SC: ["COLUMBIA", "GREENVILLE"],
  SD: ["SIOUX FALLS"],
  TN: ["NASHVILLE", "MEMPHIS", "KNOXVILLE", "CHATTANOOGA", "CLARKSVILLE"],
  TX: ["HOUSTON", "SAN ANTONIO", "DALLAS", "AUSTIN", "FORT WORTH", "EL PASO", "ARLINGTON",
    "CORPUS CHRISTI", "LUBBOCK", "LAREDO", "IRVING", "GARLAND", "PLANO", "AMARILLO",
    "BROWNSVILLE", "PASADENA", "KILLEEN", "MCALLEN"],
  UT: ["SALT LAKE CITY", "PROVO", "WEST VALLEY CITY"],
  VA: ["VIRGINIA BEACH", "RICHMOND", "NORFOLK", "CHESAPEAKE"],
  WA: ["SEATTLE", "SPOKANE", "TACOMA", "BELLEVUE"],
  WI: ["MILWAUKEE", "MADISON", "GREEN BAY"],
  WV: ["CHARLESTON", "HUNTINGTON"],
  WY: ["CHEYENNE"],
};

export const CITY_STATE = Object.entries(CITIES_BY_STATE).reduce((acc, [abbr, keys]) => {
  keys.forEach((key) => { acc[key] = abbr; });
  return acc;
}, {});

// A state as an artist record stores it ("MI", "Michigan", "mi") -> "MI", or
// null when it isn't a US state.
export function normalizeState(raw) {
  const s = (raw || "").trim().toUpperCase().replace(/\./g, "");
  if (!s) return null;
  if (s === "DC" || s === "DISTRICT OF COLUMBIA" || s === "WASHINGTON DC") return "DC";
  if (STATE_CENTROIDS[s]) return s;
  return STATE_NAME_TO_ABBR[s] || null;
}

export function stateName(abbr) {
  if (abbr === "DC") return "Washington, D.C.";
  return STATE_ABBR_TO_NAME[abbr] || abbr || "";
}

// Every US state plus DC, by display name - for the state pickers on sign-up
// ("Where are you based?") and in Fan Settings, so both store the same
// abbreviations the heat map and leaderboard filter on.
export const US_STATES = [...Object.keys(STATE_ABBR_TO_NAME), "DC"]
  .map((abbr) => ({ abbr, name: stateName(abbr) }))
  .sort((a, b) => a.name.localeCompare(b.name));

// The tracked cities, title-cased, for those forms' city suggestions. Typing
// one of these is what lets the homepage match a saved city to a scene
// (resolveCityKey above), but anything can be typed.
export const CITY_SUGGESTIONS = Object.values(CITY_DISPLAY_NAME).sort((a, b) => a.localeCompare(b));
